import styled from 'styled-components'

interface FormFieldProps {
  inline?: boolean
}
export default styled.div<FormFieldProps>`
  display: ${props => (props.inline ? 'inline-block' : 'block')};
`
